<template>

  <v-snackbar
    v-if="message"
    elevation="24"
    rounded="pill"
    location="top"
    v-model="message"
    :timeout="5000">
    {{ message }}
    <template v-slot:actions>
      <v-btn
        color="green"
        variant="text"
        @click="message = null">
        X
      </v-btn>
    </template>
  </v-snackbar>

  <transition>
    <v-card rounded="lg" v-if="show" class="mx-auto ma-2 pa-3" min-width="20em" max-width="42em" width="90%">
      <v-card-title align="start">
        <i18n-t keypath="instant.invitations_to_hint" tag="h3">
        </i18n-t>
      </v-card-title>

      <v-card-text align="start">
          <!--
          <v-text-field variant="outlined" rounded="lg" :label="$t('instant.client_mails')" @keyup.enter="addChips" @keyup.space="addChips"
                  v-model="client_mails_text">
              <template v-slot:prepend-inner>
                  <div v-for="(text , index) in client_mails" :key="index">
                      <v-chip prepend-icon="mdi-account" closable close-icon="mdi-close" @click:close="removeChip(text)" class="ma-1">{{text}}</v-chip></div>
              </template>
          </v-text-field>
-->
          <v-text-field
                  variant="outlined"
                  rounded="lg"
                  v-model="client_mails_text"
                  @keyup.enter="addChips"
                  @keyup.space="addChips"
                  :label="$t('instant.client_mails')"
                  class="chips-textfield-container">
              <template v-slot:prepend-inner>
                  <div class="chips-input-wrapper ma-2">
                      <div v-for="(text, index) in client_mails" :key="index" class="chip-item">
                          <v-chip
                                  prepend-icon="mdi-account"
                                  closable
                                  close-icon="mdi-close"
                                  @click:close="removeChip(text)"
                                  class="ma-1">
                              {{ text }}
                          </v-chip>
                      </div>
                  </div>
              </template>
          </v-text-field>


          <v-select variant="outlined" rounded="lg" v-model="language" :items="languages" item-title="name" return-object :label="$t('instant.language')" />

          <v-btn rounded="lg" size="large" color="button"
              :disabled="!create" @click="startMeeting">{{ $t('instant.start_meeting')}}</v-btn>

      </v-card-text>


    </v-card>
  </transition>
  <transition >
      <div v-if="loading">
          <v-progress-circular indeterminate color="primary" />
      </div>
  </transition>

</template>

<script>

  import languageservice from "@/services/languageservice";
  import instantmeetingservice from "@/services/instantmeetingservice";

  export default {

    data: () => ({
      loading: true,
      show: false,
      create: true,
      language: null,
      languages: [],
      message: '',
      client_mails: [],
      client_mails_text: "",
    }),
    mounted() {
      this.loadLanguages()
    },
    methods: {
      loadLanguages() {
        this.loading = true
        languageservice.get().then(languages => {
            this.languages = languages;
            this.loading = false;
            this.show = true;
        }, (error) => {
            this.loading = false;
            this.show = false
            this.message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
        })
      },
      createMeeting() {
        this.loading = true

      },
      addChips() {
          if (this.client_mails_text.length) {
              if (this.client_mails_text.trim().match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-.]+\.[a-zA-Z0-9-]{2,}$/)) {
                  this.client_mails.push(this.client_mails_text.trim())
                  this.client_mails_text = ""
                  this.message = ""
              } else {
                  this.message = this.$t("instant.invalid_mail")
                  return false
              }
          }
          return true
      },
      removeChip(chip) {
          this.client_mails.splice(this.client_mails.indexOf(chip), 1)
      },
      startMeeting() {
          if (this.addChips()) {
              if (this.client_mails.length===0 || this.language) {
                  this.create = false
                  instantmeetingservice.create(this.client_mails, this.language).then(meeting => {
                      if (meeting.participants.length === 0) {
                          window.open(meeting.url);
                      } else {
                          const routeData = this.$router.resolve({
                              name: 'instantmeeting', params: {
                                  id: meeting.key
                              }
                          });
                          window.open(routeData.href);
                      }
                      this.client_mails = [];
                      this.create = true;
                  }, (error) => {
                      this.message =
                          (error.response &&
                              error.response.data &&
                              error.response.data.message) ||
                          error.message ||
                          error.toString();
                      this.create = true
                  })
              } else this.message = this.$t('instant.select_language')
          }
      }
    },

  }
</script>

<style scoped>

h3 {
    font-family: "Nunito Sans Bold";
    font-size: 1.0em;
}

.chips-textfield-container {
    /* Zusätzliche Stile für das gesamte Textfeld */
}

.chips-input-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.chip-item {
    /* Stile für einzelne Chip-Elemente */
}

.textfield-input {
    flex-grow: 1;
    border: none;
    outline: none;
    /* Weitere Anpassungen für das Eingabefeld */
}


</style>
